import { render } from "./AccessRequestSummary.vue?vue&type=template&id=e2e1ae72"
import script from "./AccessRequestSummary.vue?vue&type=script&lang=js"
export * from "./AccessRequestSummary.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__